import styled, { keyframes } from 'styled-components';
import { palette } from 'styled-tools';

export const Overflow = styled.div`
  position: absolute;
  z-index: 9;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${palette('bgBodyTransparent')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const rotate = keyframes`
  from { 
    transform: rotate(0deg) 
  }
  to { 
    transform: rotate(360deg) 
  }
`;

export const LoadingIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid ${palette('primary')};
  border-top-width: 0;
  border-left-width: 0;
  animation: ${rotate} 1s linear infinite;
`;
